import React from 'react';
function Retry({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M4 10C4 5.6 7.6 2 12 2C16.4 2 20 5.6 20 10C20 14.4 16.4 18 12 18H4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 22L4 18L8 14" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default Retry;
